<template>
  <div class="qsc-wrap">
    <canvas ref="canvas" class="qsc-canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { markRaw } from "vue";

export default {
  name: "QuantySuscriptoresChart",
  props: {
    id:        { type: String, required: true },
    labels:    { type: Array, default: () => [] },
    altas:     { type: Array, default: () => [] },
    bajas:     { type: Array, default: () => [] },
    acumulado: { type: Array, default: () => [] },
  },
  data() {
    return { chart: null };
  },
  mounted() {
    this.initChart();
  },
  beforeUnmount() {
    if (this.chart) { this.chart.destroy(); this.chart = null; }
  },
  methods: {
    initChart() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      if (this.chart) { this.chart.destroy(); this.chart = null; }

      const ctx = canvas.getContext("2d");

      const gradAltas = ctx.createLinearGradient(0, 0, 0, 260);
      gradAltas.addColorStop(0, "rgba(67,160,71,0.85)");
      gradAltas.addColorStop(1, "rgba(67,160,71,0.45)");

      const gradBajas = ctx.createLinearGradient(0, 0, 0, 260);
      gradBajas.addColorStop(0, "rgba(229,57,53,0.80)");
      gradBajas.addColorStop(1, "rgba(229,57,53,0.40)");

      const gradAcum = ctx.createLinearGradient(0, 0, 0, 260);
      gradAcum.addColorStop(0, "rgba(30,136,229,0.18)");
      gradAcum.addColorStop(1, "rgba(30,136,229,0.01)");

      this.chart = markRaw(new Chart(canvas, {
        type: "bar",
        data: {
          labels: [...this.labels],
          datasets: [
            {
              type: "bar",
              label: "Altas",
              data: [...this.altas],
              backgroundColor: gradAltas,
              borderRadius: 7,
              borderSkipped: false,
              maxBarThickness: 40,
              order: 2,
            },
            {
              type: "bar",
              label: "Bajas",
              data: [...this.bajas],
              backgroundColor: gradBajas,
              borderRadius: 7,
              borderSkipped: false,
              maxBarThickness: 40,
              order: 2,
            },
            {
              type: "line",
              label: "Acumulado",
              data: [...this.acumulado],
              yAxisID: "yAcum",
              borderColor: "#f5a623",
              backgroundColor: gradAcum,
              fill: true,
              tension: 0.38,
              pointRadius: 5,
              pointHoverRadius: 7,
              pointBackgroundColor: "#f5a623",
              borderWidth: 2.5,
              order: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: "index", intersect: false },
          plugins: {
            legend: {
              display: true,
              position: "top",
              align: "end",
              labels: {
                boxWidth: 12,
                boxHeight: 12,
                borderRadius: 4,
                useBorderRadius: true,
                font: { size: 12, family: "Inter" },
                color: "#e7edf5",
              },
            },
            tooltip: {
              backgroundColor: "rgba(14,20,31,0.96)",
              titleFont: { size: 12, family: "Inter" },
              bodyFont:  { size: 12, family: "Inter" },
              padding: 10,
              callbacks: {
                label: (ctx) => {
                  if (ctx.datasetIndex === 0) return `  Altas: +${ctx.raw}`;
                  if (ctx.datasetIndex === 1) return `  Bajas: -${ctx.raw}`;
                  return `  Acumulado: ${ctx.raw}`;
                },
              },
            },
          },
          scales: {
            x: {
              grid: { display: false, drawBorder: false },
              ticks: { color: "#7b8ea8", font: { size: 11, family: "Inter" } },
            },
            y: {
              position: "left",
              grid: { color: "rgba(255,255,255,0.05)", drawBorder: false },
              ticks: {
                stepSize: 1,
                color: "#7c8ba1",
                font: { size: 11, family: "Inter" },
                callback: (v) => Number.isInteger(v) ? v : null,
              },
              title: {
                display: true,
                text: "Altas / Bajas",
                color: "#7c8ba1",
                font: { size: 11, family: "Inter" },
              },
            },
            yAcum: {
              position: "right",
              grid: { display: false, drawBorder: false },
              ticks: {
                stepSize: 1,
                color: "#f5a623",
                font: { size: 11, family: "Inter" },
                callback: (v) => Number.isInteger(v) ? v : null,
              },
              title: {
                display: true,
                text: "Acumulado",
                color: "#f5a623",
                font: { size: 11, family: "Inter" },
              },
            },
          },
        },
      }));
    },
  },
};
</script>

<style scoped>
.qsc-wrap  { position: relative; width: 100%; height: 280px; }
.qsc-canvas{ width: 100% !important; height: 100% !important; }
</style>
